import { useQuery } from '@apollo/client';
import useIsBrowser from 'hooks/useIsBrowser';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import { GET_FABRIC_REVIEWS } from '../../mocks/queries';

const useFabricReviews = fabricId => {
  const isBrowser = useIsBrowser();

  const { loading, error, data } = useQuery(GET_FABRIC_REVIEWS, {
    variables: { fabricValueId: fabricId?.toString() },
    skip: (isNewConsumerApp && !isBrowser) || !fabricId,
  });

  return {
    loading,
    error,
    data: {
      rating: data?.getFabricReviews?.rating,
      reviews: data?.getFabricReviews?.reviews,
    },
  };
};

export default useFabricReviews;
